"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var pace_1 = require("./pace");
var time_1 = require("./time");
// start of the speed IPace mappings
var getMilesPerHourSpeed = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.HOURS
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.MILES
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.SPEED
    };
    return pace;
};
var getKilometersPerHourSpeed = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.HOURS
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.KILO_METERS
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.SPEED
    };
    return pace;
};
var get100MetersPerMinuteSpeed = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.MINUTES
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.HECTA_METERS
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.SPEED
    };
    return pace;
};
var get100YardsPerMinuteSpeed = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.MINUTES
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.HECTA_YARDS
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.SPEED
    };
    return pace;
};
var getYardsPerSecondSpeed = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.SECONDS
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.YARDS
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.SPEED
    };
    return pace;
};
var getFeetPerSecondSpeed = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.SECONDS
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.FEET
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.SPEED
    };
    return pace;
};
var getMetersPerSecondSpeed = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.SECONDS
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.METERS
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.SPEED
    };
    return pace;
};
// start of the pace IPace mappings
var getMinuteMilePace = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.MINUTES
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.MILES
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.PACE
    };
    return pace;
};
var getMinuteKilometerPace = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.MINUTES
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.KILO_METERS
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.PACE
    };
    return pace;
};
var getMin100YdPace = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.MINUTES
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.HECTA_YARDS
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.PACE
    };
    return pace;
};
var getMin100MetersPace = function (timeInMilliseconds, distanceInMeters) {
    var time = {
        timeInMillis: timeInMilliseconds,
        timeUnit: __1.TimeUnit.MINUTES
    };
    var distance = {
        distanceInMeters: distanceInMeters,
        distanceUnit: __1.DistanceUnit.HECTA_METERS
    };
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.PACE
    };
    return pace;
};
var getDefaultPace = function (timeInMilliseconds, distanceInMeters) {
    var time = new time_1.Time();
    time.timeInMillis = timeInMilliseconds;
    var distance = new __1.Distance();
    distance.distanceInMeters = distanceInMeters;
    var pace = {
        distance: distance,
        time: time,
        paceType: pace_1.PaceType.NOTCALCULATED
    };
    return pace;
};
// MilesPerHour = 'mph',
// KilometersPerHour = 'kph',
// HectaMeterPerMinute = '100m/min',
// HectaYardPerMinute = '100yd/min',
// MinutePerMile = 'min/mi',
// MinutePerKilometer = 'min/km',
// MinutePerHectaYard = 'min/100yd',
// MinutePerHectaMeter = 'min/100m'
// Our current systems stores min/mi, mph, kph, 100m/min, ect as the pace unit.
// This function converts that to a the IPace object.
exports.convertToPace = function (paceUnit, timeInMilliseconds, distanceInMeters) {
    // map the speed pace units
    if (paceUnit.toLowerCase() === 'mph' || paceUnit.toLowerCase() === 'mi/hr') {
        return getMilesPerHourSpeed(timeInMilliseconds, distanceInMeters);
    }
    if (paceUnit.toLowerCase() === 'kph' || paceUnit.toLowerCase() === 'km/hr') {
        return getKilometersPerHourSpeed(timeInMilliseconds, distanceInMeters);
    }
    if (paceUnit.toLowerCase() === '100m/min') {
        return get100MetersPerMinuteSpeed(timeInMilliseconds, distanceInMeters);
    }
    if (paceUnit.toLowerCase() === '100yd/min') {
        return get100YardsPerMinuteSpeed(timeInMilliseconds, distanceInMeters);
    }
    if (paceUnit.toLowerCase() === 'yd/s') {
        return getYardsPerSecondSpeed(timeInMilliseconds, distanceInMeters);
    }
    if (paceUnit.toLowerCase() === 'ft/s') {
        return getFeetPerSecondSpeed(timeInMilliseconds, distanceInMeters);
    }
    if (paceUnit.toLowerCase() === 'm/s') {
        return getMetersPerSecondSpeed(timeInMilliseconds, distanceInMeters);
    }
    // map the pace paceUnits
    if (paceUnit.toLowerCase() === 'min/mi') {
        return getMinuteMilePace(timeInMilliseconds, distanceInMeters);
    }
    if (paceUnit.toLowerCase() === 'min/km') {
        return getMinuteKilometerPace(timeInMilliseconds, distanceInMeters);
    }
    if (paceUnit.toLowerCase() === 'min/100m') {
        return getMin100MetersPace(timeInMilliseconds, distanceInMeters);
    }
    if (paceUnit.toLowerCase() === 'min/100yd') {
        return getMin100YdPace(timeInMilliseconds, distanceInMeters);
    }
    return getDefaultPace(timeInMilliseconds, distanceInMeters);
};
//# sourceMappingURL=paceUnitToIPaceConverter.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-model/dist/common/paceUnitToIPaceConverter.js
 ** module id = 2094
 ** module chunks = 0
 **/